import api from '../api';

const API = 'practices';
const PENDING = `${API}_PENDING`;
const FULFILLED = `${API}_FULFILLED`;
const REJECTED = `${API}_REJECTED`;
const FOUND = `${API}_FOUND`;

const initialState = {
  data: [],
  currentId: null,
  fetching: false,
  fetched: false,
  errors: []
};

export default (state = initialState, action = {}) => {
  const { type, payload, meta } = action;
  switch (type) {
    case PENDING: return {...state, fetching: true, fetched: false};
    case REJECTED: return {...initialState, errors: payload};
    case FULFILLED: return { data: [...payload.data], currentId: meta, fetching: false, fetched: true};
    case FOUND: return state; // just for clarity
    default: return state;
  }
}

// API
export const apiPractices = () => ({
  type: API,
  payload: api.getPractices()
});

// Action Creator
export const getPractices = () => {
  return (dispatch, getState) => {
    const { practices } = getState();
    if (practices.fetched) dispatch({ type: FOUND});
    else dispatch(apiPractices());
  };
}